"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _CustomPropertiesEditCtx = _interopRequireDefault(require("./CustomPropertiesEditCtx"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const CustomPropertiesEdit = _ref => {
  let {
    contexts = [],
    customPropertiesEndpoint,
    id,
    intlKey: passedIntlKey,
    intlNS: passedIntlNS,
    labelOverrides = {},
    nameOverride
  } = _ref;
  return contexts.map(ctx => /*#__PURE__*/(0, _jsxRuntime.jsx)(_CustomPropertiesEditCtx.default, {
    ctx,
    customPropertiesEndpoint,
    id,
    intlKey: passedIntlKey,
    intlNS: passedIntlNS,
    labelOverrides,
    nameOverride
  }, "customPropertiesEdit-".concat(ctx)));
};
CustomPropertiesEdit.propTypes = {
  contexts: _propTypes.default.arrayOf(_propTypes.default.string),
  customPropertiesEndpoint: _propTypes.default.string,
  id: _propTypes.default.string,
  intlKey: _propTypes.default.string,
  intlNS: _propTypes.default.string,
  labelOverrides: _propTypes.default.object,
  nameOverride: _propTypes.default.string
};
var _default = exports.default = CustomPropertiesEdit;